// extracted by css-extract-rspack-plugin
export default {"Box":"DeleteHeaderButtons-module__Box__lSluH"};